import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import{
    LayoutPlugin,
    VBScrollspyPlugin,
    CardPlugin,
    TabsPlugin,
    CollapsePlugin,
    NavPlugin,
    ButtonPlugin,
    NavbarPlugin
} from "bootstrap-vue";
// mport { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/scss/bootstrap.scss";

import "bootstrap-vue/dist/bootstrap-vue.css";

// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VuePageTransition from 'vue-page-transition'


import Footer from "@/common/layout/footer.vue";
import Header from "@/common/layout/header.vue";

import "vue-slick-carousel/dist/vue-slick-carousel.css";

import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import vuescroll from "vuescroll";

import VueNumber from 'vue-number-animation';
import AOS from "aos";
import "aos/dist/aos.css";
import "vue-page-transition/dist/vue-page-transition.css";

// import { TabsPlugin } from "bootstrap-vue";
import animation from '@/mixin/animation.js';
import "@/assets/css/animate.min.css";
// import wow from "@/assets/js/wow.min.js";

import Sticky from 'vue-sticky-directive'
// import { mixin } from "vue/types/umd";
// import 'wowjs/css/libs/animate.css'

// Scroll component

// import locomotiveScroll from "locomotive-scroll";
// import "locomotive-scroll/dist/locomotive-scroll.css";

import vWow from 'v-wow'
Vue.use(vWow);




//FontAwsome
// library.add(faUserSecret);
// Install BootstrapVue
Vue.use(LayoutPlugin);
Vue.use(VBScrollspyPlugin);
Vue.use(CardPlugin);
Vue.use(TabsPlugin);
Vue.use(CollapsePlugin);
Vue.use(NavPlugin);
Vue.use(ButtonPlugin);
Vue.use(NavbarPlugin);
Vue.use(Sticky)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin);
Vue.use(VuePageTransition);
Vue.mixin(animation);

// Vue.component("innerBanner", innerBanner);
// Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("scrollbar", vuescroll);
Vue.component("Footer", Footer)
Vue.component("Header", Header)
    //Vue.component("vue-page-transition", VuePageTransition)
    // Vue.component("locomotiveScroll", locomotiveScroll)

// NumberAnnimation 
Vue.use(VueNumber)
Vue.use(animation)

Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
    let language = to.params.lang;
    if (!language) {
        language = 'en'
    }
    i18n.locale = language
    next()
});

Vue.mixin({
    created: function() {
        // this.gsap = gsap;
        // this.ScrollTrigger = ScrollTrigger;
    },
    methods: {

    }
});




new Vue({
    router,
    AOS,
    created() {
        AOS.init({
            offset: 50,
            // disable: 'mobile'
        });
    },
    i18n,
    render: h => h(App)
}).$mount("#app");